import { CSSProperties, MouseEventHandler, ReactNode } from "react";
import { GenericComponentProps, makeStyles } from "../../../utils/genericComponentProps";

export type SpacerProps = GenericComponentProps & {
  line?: boolean;
  lineStyle?: CSSProperties;
  children?: ReactNode;

  onClick?: MouseEventHandler<HTMLDivElement>;
  dataCy?: string;
};

export const Spacer = ({ line, lineStyle, children, onClick, dataCy, ...props }: SpacerProps) => {
  const style = makeStyles(props);

  return line ? (
    <div data-cy={dataCy} style={{ display: "flex", alignItems: "center", cursor: onClick ? "pointer" : "default", ...style }} onClick={onClick}>
      <div style={{ backgroundColor: "#f5f2f5", height: "2px", width: "100%", borderRadius: "2px", ...lineStyle }}></div>
      {children ? (
        <>
          <div style={{ margin: "0 0.5em", display: "flex", alignItems: "center", flexShrink: "0" }}>{children}</div>
          <div style={{ backgroundColor: "#f5f2f5", height: "2px", width: "100%", borderRadius: "2px" }}></div>
        </>
      ) : undefined}
    </div>
  ) : (
    <span style={{ flexGrow: 1 }} />
  );
};
